import { createContext } from 'react';

let PdfViewerContext = createContext({});
export default PdfViewerContext;